export function Loading({ label = "Завантаження…" }: { label?: string }) {
  return <div className="text-tg-hint text-center p-8">{label}</div>;
}

export function ErrorBox({ message }: { message: string }) {
  return (
    <div className="bg-red-50 text-red-800 rounded-xl p-3 text-sm">{message}</div>
  );
}

export function Empty({ label }: { label: string }) {
  return <div className="text-tg-hint text-center p-8 text-sm">{label}</div>;
}
